<template>
  <main class="app-main">
    <posts v-if="$route.params.id"/>
  </main>
</template>

<script>
import Posts from './components/posts/index.vue';

export default {
  name: "Home",
  components: {
    Posts
  }
};
</script>

<style>
@import "./css/style.css";
</style>
